import React, {useRef} from 'react'
import Modal from "./index";
import DialogDefaultFooter from './modal-footer'
import {classNames} from "../../util/util-helpers";
import ButtonClose from "../button/button-close";

export default function ModalDefault({
                                         show,
                                         initialFocusRef,
                                         focusXButton,
                                         widthClass,
                                         hideOverlay,
                                         onClose,
                                         onBackdropClick,
                                         isLoading,
                                         onButtonClick,
                                         buttonDisabled,
                                         buttonLabel,
                                         onSecondaryButtonClick,
                                         secondaryButtonLabel,
                                         customHtmlLeft = null,
                                         customHtmlRight = null,
                                         title,
                                         customButtonsHTML,
                                         secondaryButtonDisabled,
                                         closeButtonLabel,
                                         closeButtonDisabled,
                                         middleButtonLabel,
                                         middleButtonID,
                                         middleButtonDisabled,
                                         onMiddleButtonClick,
                                         options,
                                         hideXBtn,
                                         children,
                                         limitHeight,
                                         hideDialogFooter,
                                         addClass,
                                         baseClass,
                                         afterTitle,
                                         modalClass,
                                         submitButtonRef,
                                         hideDialogHeader,
                                     }) {
    const closeButtonRef = useRef(null);

    return (
        <Modal
            baseClass={baseClass}
            show={show}
            modalClass={modalClass}
            hideOverlay={hideOverlay}
            onClose={onClose}
            widthClass={widthClass}
            onBackdropClick={onBackdropClick}
            initialFocusRef={initialFocusRef ?? closeButtonRef}
        >
            <div className="relative">
                {!hideDialogHeader && (
                    <header
                        className="p-4 flex items-center border-tm-gray-200 border-b text-tm-gray-900 relative bg-popup rounded-t-md">
                        <h2 className="text-lg text-current truncate">{title}</h2>

                        {!!afterTitle && (
                            <div>{afterTitle}</div>
                        )}

                        {!!options && (
                            <div className="ml-auto pr-14">
                                {options}
                            </div>
                        )}

                        {!hideXBtn && focusXButton && (
                            <ButtonClose onClose={onClose}/>
                        )}
                    </header>
                )}

                <div
                    className={
                        classNames(
                            limitHeight ? "h-dialog-body" : "",
                            isLoading ? "invisible" : "",
                            addClass, "bg-popup"
                        )
                    }
                >
                    {children}
                </div>

                {!hideDialogFooter && (
                    <DialogDefaultFooter
                        buttonLabel={buttonLabel}
                        buttonDisabled={buttonDisabled}
                        onButtonClick={onButtonClick}

                        closeButtonLabel={closeButtonLabel}
                        closeButtonDisabled={closeButtonDisabled}
                        onClose={onClose}

                        middleButtonLabel={middleButtonLabel}
                        middleButtonID={middleButtonID}
                        middleButtonDisabled={middleButtonDisabled}
                        onMiddleButtonClick={onMiddleButtonClick}

                        secondaryButtonLabel={secondaryButtonLabel}
                        secondaryButtonDisabled={secondaryButtonDisabled}
                        onSecondaryButtonClick={onSecondaryButtonClick}

                        customHtmlLeft={customHtmlLeft}
                        customHtmlRight={customHtmlRight}
                        submitButtonRef={submitButtonRef}
                    >
                        {!!customButtonsHTML && (
                            customButtonsHTML
                        )}
                    </DialogDefaultFooter>
                )}

                {!hideXBtn && !focusXButton && (
                    <ButtonClose onClose={onClose}/>
                )}
            </div>
        </Modal>
    )
}
